export default __webpack_public_path__ + "static/media/try2.b2a215f1.csv";